import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { StateMessage } from "@gemini/ui";
import { memo } from "react";
export const createTabPanel = ({ label, description, Component, }) => {
    return {
        id: label,
        label,
        Component: memo(({ children, ...componentProps }) => {
            return (_jsxs(Box, { as: "section", display: "flex", flexDirection: "column", paddingHorizontal: "spacing.12", paddingVertical: "spacing.20", height: 400, children: [_jsxs(StateMessage, { variant: "info", marginBottom: "spacing.20", children: [description, ":"] }), _jsx(Component, { ...componentProps, children: children })] }));
        }),
    };
};
